module.exports = __webpack_public_path__ + "img/SOKAL-SRS-Chevy-120921-DealerDraft-Modern.ede269da.jpeg";